import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

type Props = { urlsOfExternalDocumentsType: string[]; copyId: string };

const ListItem = styled.span`
  cursor: pointer;

  &:not(:last-child)::after {
    content: ',';
  }

  &:last-child::after {
    content: '.';
  }
`;

const Link = styled.a`
  white-space: nowrap;
`;

export const ExternalDocumentList: React.FC<Props> = ({ urlsOfExternalDocumentsType, copyId }) => {
  return (
    <>
      {urlsOfExternalDocumentsType.map((url, i) => (
        <ListItem key={url}>
          {' '}
          <Link href={url} target="_blank" data-testid="xing-apply-privacy-policy-link" rel="noreferrer">
            <FormattedMessage id={copyId} />
            {urlsOfExternalDocumentsType.length > 1 ? ` ${i + 1}` : ''}
          </Link>
        </ListItem>
      ))}
    </>
  );
};
